import Helper from "../functions/Helper.js";
import { Svg, View } from "@react-pdf/renderer";
import PdfNCAACourt from "./courts/PdfNCAACourt.jsx";
import PdfNCAAFullCourt from "./courts/PdfNCAAFullCourt.jsx";
import PdfNBACourt from "./courts/PdfNBACourt.jsx";
import PdfNBAFullCourt from "./courts/PdfNBAFullCourt.jsx";
import PdfHighSchoolCourt from "./courts/PdfHighSchoolCourt.jsx";
import PdfHighSchoolFullCourt from "./courts/PdfHighSchoolFullCourt.jsx";
import PdfFIBACourt from "./courts/PdfFIBACourt.jsx";
import PdfFIBAFullCourt from "./courts/PdfFIBAFullCourt.jsx";
import Player from "./Player.jsx";
import Rectangle from "./Rectangle.jsx";
import Circle from "./Circle.jsx";
import TextObject from "./Text.jsx";
import Polygon from "./Polygon.jsx";
import Arrow from "./Arrow.jsx";
import PDFBackground from "./PDFBackground.jsx";

export default function Phase(props) {
  const objectSizeFactor = props.objectSizeFactor ?? 1;

  let transformedObjects = Helper.transformObjects(
    props.phase.objects,
    props.court
  );

  transformedObjects.sort((a, b) => {
    return a.displayOrder - b.displayOrder;
  });

  let viewBoxX = props.court.full
    ? props.court.sidelines * -1
    : (props.court.width / 2 + props.court.sidelines) * -1;
  let viewBoxY = props.court.full
    ? (props.court.width / 2 + props.court.sidelines) * -1
    : props.court.sidelines * -1;
  let viewBoxWidth = props.court.full
    ? props.court.length + 2 * props.court.sidelines
    : props.court.width + 2 * props.court.sidelines;
  let viewBoxHeight = props.court.full
    ? props.court.width + 2 * props.court.sidelines
    : (props.court.length + 2 * props.court.sidelines) / 2;

  let lineColor = props.courtColor.lineColor;
  let objectSizes = Helper.getObjectSizes(600, props.court);

  let securitySizingFactor = props.maxHeight
    ? Math.min(1, props.maxHeight / Helper.getHeight(props.width, props.court))
    : 1;

  let courtProps = {
    pdf: true,
    lineColor: lineColor,
    courtColor: props.courtColor,
    ...props.court,
  };

  return (
    <>
      <View
        style={{
          position: "relative",
          border: props.court.sidelines > 0 ? "0.5px solid black" : "0px",
          width: securitySizingFactor * props.width,
          height:
            securitySizingFactor * Helper.getHeight(props.width, props.court),
        }}
      >
        <Svg
          preserveAspectRatio="xMinYMin meet"
          style={{
            //border: "1px solid black",
            marginRight: 10,
            width: "100%",
            height: "100%",
            //backgroundColor: props.courtColor.backgroundColor,
          }}
          viewBox={
            viewBoxX + " " + viewBoxY + " " + viewBoxWidth + " " + viewBoxHeight
          }
        >
          <PDFBackground courtColor={props.courtColor} court={props.court} />
          {props.court.type === "NCAA" && !props.court.full && (
            <PdfNCAACourt {...courtProps} />
          )}
          {props.court.type === "NCAA" && props.court.full && (
            <PdfNCAAFullCourt {...courtProps} />
          )}
          {props.court.type === "NBA" && !props.court.full && (
            <PdfNBACourt {...courtProps} />
          )}
          {props.court.type === "NBA" && props.court.full && (
            <PdfNBAFullCourt {...courtProps} />
          )}
          {props.court.type === "HighSchool" && !props.court.full && (
            <PdfHighSchoolCourt {...courtProps} />
          )}
          {props.court.type === "HighSchool" && props.court.full && (
            <PdfHighSchoolFullCourt {...courtProps} />
          )}
          {props.court.type === "FIBA" && !props.court.full && (
            <PdfFIBACourt {...courtProps} />
          )}
          {props.court.type === "FIBA" && props.court.full && (
            <PdfFIBAFullCourt {...courtProps} />
          )}
          {transformedObjects.map((object) => {
            /*
            if (object.subType === "text") {
              return (
                <TextObject
                  key={"text_" + object.id}
                  frameWidth={props.width}
                  court={props.court}
                  {...object}
                />
              );
            } else */ if (
              object.subType === "polygon" ||
              object.subType === "triangle"
            ) {
              return (
                <Polygon
                  key={"polygon_" + object.id}
                  frameWidth={props.width}
                  court={props.court}
                  {...object}
                />
              );
            } else if (object.subType === "rectangle") {
              return (
                <Rectangle
                  frameWidth={props.width}
                  court={props.court}
                  key={"rect_" + object.id}
                  {...object}
                />
              );
            } else if (object.subType === "circle") {
              return (
                <Circle
                  frameWidth={props.width}
                  court={props.court}
                  key={"rect_" + object.id}
                  {...object}
                />
              );
            } else if (object.type === "arrow") {
              return (
                <Arrow
                  objectSizes={objectSizes.viewbox}
                  objectSizeFactor={objectSizeFactor}
                  links={props.phase.links.filter(
                    (x) =>
                      x.object.id === object.id || x.player.id === object.id
                  )}
                  scalingFactor={props.court.full ? 1.3 : 1}
                  editable={props.editable}
                  phaseId={props.id}
                  key={"arrow_" + object.id}
                  {...object}
                />
              );
            } else if (
              ["cone", "player", "handoff", "hoop"].includes(object.subType)
            ) {
              return (
                <Player
                  objectSizeFactor={objectSizeFactor}
                  objectSizes={objectSizes.viewbox}
                  court={props.court}
                  phaseId={0}
                  key={"player_" + object.id}
                  {...object}
                />
              );
            }
          })}

          {/*
          {transformedObjects
            .filter((x) => x.subType === "rectangle")
            .map((object) => (
              <Rectangle
                frameWidth={props.width}
                court={props.court}
                key={"rect_" + object.id}
                {...object}
              />
            ))}
          {transformedObjects
            .filter((x) => x.subType === "circle")
            .map((object) => (
              <Circle
                frameWidth={props.width}
                court={props.court}
                key={"rect_" + object.id}
                {...object}
              />
            ))}
          {transformedObjects
            .filter((x) => x.type === "arrow")
            .map((object) => (
              <Arrow
                links={props.phase.links.filter(
                  (x) => x.object.id === object.id
                )}
                scalingFactor={props.court.full ? 1.3 : 1}
                editable={props.editable}
                phaseId={props.id}
                key={"arrow_" + object.id}
                {...object}
              />
            ))}
          {transformedObjects
            .filter((x) => x.type === "object")
            .map((object) => {
              if (object.subType !== "text") {
                return (
                  <Player
                    objectSizes={objectSizes.viewbox}
                    court={props.court}
                    phaseId={0}
                    key={"player_" + object.id}
                    {...object}
                  />
                );
              }
            })}
          {transformedObjects
            .filter((x) => x.subType === "polygon" || x.subType === "triangle")
            .map((object) => (
              <Polygon
                key={"polygon_" + object.id}
                frameWidth={props.width}
                court={props.court}
                {...object}
              />
            ))}{" "}
            */}
        </Svg>

        {transformedObjects
          .filter((x) => x.subType === "text")
          .map((object) => (
            <TextObject
              key={"text_" + object.id}
              frameWidth={props.width}
              court={props.court}
              {...object}
            />
          ))}
      </View>
    </>
  );
}
